'use client'

import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/routing'
import { MaterialIcon } from '@/components/ui/MaterialIcon'

interface ToolStepIndicatorProps {
    currentStep: 1 | 2 | 3
    baseUrl: string
}

export function ToolStepIndicator({ currentStep, baseUrl }: ToolStepIndicatorProps) {
    const t = useTranslations('StepIndicator')
    const steps = [
        { label: t('upload'), icon: 'upload_file' },
        { label: t('configure'), icon: 'tune' },
        { label: t('download'), icon: 'download' },
    ]
    const urls = [baseUrl, `${baseUrl}/configurar`, `${baseUrl}/download`]

    return (
        <div className="mx-auto mb-8 flex max-w-md items-center justify-center gap-0">
            {steps.map((step, i) => {
                const stepNum = i + 1
                const isActive = stepNum === currentStep
                const isCompleted = stepNum < currentStep

                const content = (
                    <div className="flex flex-col items-center gap-1.5">
                        <div
                            className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold transition-all ${
                                isActive
                                    ? 'bg-primary text-white shadow-lg shadow-primary/30'
                                    : isCompleted
                                      ? 'bg-green-500 text-white'
                                      : 'bg-slate-200 text-slate-400'
                            }`}
                        >
                            {isCompleted ? (
                                <MaterialIcon name="check" className="text-lg" />
                            ) : (
                                <MaterialIcon name={step.icon} className="text-lg" />
                            )}
                        </div>
                        <span
                            className={`text-xs font-semibold ${
                                isActive ? 'text-primary' : isCompleted ? 'text-green-600' : 'text-slate-400'
                            }`}
                        >
                            {step.label}
                        </span>
                    </div>
                )

                return (
                    <div key={step.label} className="flex items-center">
                        {i > 0 && (
                            <div
                                className={`mx-3 h-0.5 w-12 sm:w-16 ${
                                    isCompleted || isActive ? 'bg-primary/30' : 'bg-slate-200'
                                }`}
                            />
                        )}
                        {isCompleted ? (
                            <Link href={urls[i]} className="transition-opacity hover:opacity-80">
                                {content}
                            </Link>
                        ) : (
                            content
                        )}
                    </div>
                )
            })}
        </div>
    )
}
